import { render, staticRenderFns } from "./goujiantouzizuhe.vue?vue&type=template&id=dffc9f1c&scoped=true"
import script from "./goujiantouzizuhe.vue?vue&type=script&lang=js"
export * from "./goujiantouzizuhe.vue?vue&type=script&lang=js"
import style0 from "./goujiantouzizuhe.vue?vue&type=style&index=0&id=dffc9f1c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dffc9f1c",
  null
  
)

export default component.exports